module.exports = __webpack_public_path__ + "toGroom-we-b-g.1e6f2d2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-b-g.jpg
// module id = GJoR
// module chunks = 0